import { Episode } from "@/types/Episode";
import { Mention } from "@/types/Mention";
import { AudioMentionV4 } from "@/types/MentionCard";

const quote = (content: string) => `<i>”</i>${content}<i>”</i>`;

const mergeTranscriptAndTrimmedContent = ({
  grouped_times_and_words: { words, times },
  mentions,
  removedMentionIds = [],
}: Pick<Episode, "grouped_times_and_words"> & {
  mentions: Mention[] | AudioMentionV4[];
  removedMentionIds?: string[];
}) => {
  const mentionIndices: [start: number, end: number, removed: boolean][] = [];

  // Construct a full transcript
  const transcript = words.join(" ");
  const updatedWords: string[] = [...words]; // copy transcript words

  let wordCountDiff = 0;

  for (const index in mentions) {
    const mention = mentions[index];

    // Normalize the content
    const trimmedText = mention.trimmed_content
      .replaceAll("<b>", "")
      .replaceAll("</b>", "")
      .replaceAll("…", "");

    const trimmedWords: string[] = trimmedText.split(" ");

    let amendedWordsString = mentions[index].amended_text;
    let originalTrimmedAmendedWords: string[] = [];

    if (amendedWordsString) {
      amendedWordsString = quote(amendedWordsString).replaceAll("…", "");
      originalTrimmedAmendedWords = amendedWordsString.split(" ");
    }

    // Find out where the normalized mention starts within the transcript
    // Move position to account for the difference in length between original
    // and amended text
    const startsAt = transcript.indexOf(trimmedText) + wordCountDiff;

    // Find out how many words are before
    const wordsBefore =
      transcript.slice(0, startsAt).split(" ").length - 1 || 0;

    if (mention.amended_text) {
      // move start position for the next iteration to account for different
      // length between original and amended text
      wordCountDiff += originalTrimmedAmendedWords.length - trimmedWords.length;
      mentionIndices.push([
        wordsBefore,
        wordsBefore + originalTrimmedAmendedWords.length - 1,
        removedMentionIds.includes(mention.public_id),
      ]);

      // Replace the words in the transcript with the amended words, taking
      // into account possible differences in length between the two
      updatedWords.splice(
        wordsBefore,
        trimmedWords.length,
        ...originalTrimmedAmendedWords
      );
    } else {
      mentionIndices.push([
        wordsBefore,
        wordsBefore + trimmedWords.length - 1,
        removedMentionIds.includes(mention.public_id),
      ]);

      let wordsString = mentions[index].trimmed_content;
      let originalTrimmedWords: string[] = [];

      if (wordsString) {
        wordsString = quote(wordsString).replaceAll("…", "");
        originalTrimmedWords = wordsString.split(" ");
      }

      // Replace the words in the transcript with the amended words
      updatedWords.splice(
        wordsBefore,
        trimmedWords.length,
        ...originalTrimmedWords
      );
    }
  }

  return {
    mentionIndices,
    words: updatedWords,
    times,
  };
};

export default mergeTranscriptAndTrimmedContent;
